const Config = {
    productionAPIUrl: 'https://api.lorie.app',
    developmentAPIUrl: 'http://localhost:8080',
};

export const getAPIUrl = () => {
    return process.env.NODE_ENV === 'development'
        ? Config.developmentAPIUrl
        : Config.productionAPIUrl;
};
